<template>
    <el-select v-model="userInfoRef.lang" :size="null == domSize ? '' : 'large'" @change="changeLang">
        <el-option
            v-for="(v, k) in langSet"
            :key="k"
            :label="v"
            :value="k"
        />

    </el-select>
</template>

<script setup>
    import {inject, toRef, ref, onMounted} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import cookie from "@/util/cookie";

    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(["domSize", "confirmFlag"])

    const i18n = inject("i18n")

    const langSet = ref({})

    function getLangSet(){
        langSet.value = i18n.getLangs()
    }

    function changeLang(){
        let langText = userInfoRef.value.lang

        if (langText === "szh"){
            langText = "zh"
        }

        cookie.setCookie("lang", langText, {path: '/'})

        if (false == props.confirmFlag){
            return
        }

        myUtil.confirmSuccess(i18n.tkey("lang_change_lang_confirm"), () => {
            location.reload()
        })
    }

    onMounted(() => {
        getLangSet()
    })
</script>

<style scoped>

</style>